export const DEFAULT_CURRENCY_CODE = 'GBP';
export const CUSTOMER_TITLES = ['Mr.', 'Mrs.', 'Miss', 'Ms', 'Dr.'];
